import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c54e81a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addon-view-processing-color" }
const _hoisted_2 = { class: "level is-mobile" }
const _hoisted_3 = { class: "level is-mobile" }
const _hoisted_4 = { class: "has-text-table-cell-title has-text-modest" }
const _hoisted_5 = { class: "addon-view-processing-color-controls-desktop level is-hidden-mobile" }
const _hoisted_6 = {
  id: "addon-view-processing-color-brightness-label",
  class: "has-text-table-item-name"
}
const _hoisted_7 = { class: "level" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "addon-view-processing-color-unit is-hidden-mobile" }, "%", -1))
const _hoisted_9 = {
  id: "addon-view-processing-color-contrast-label",
  class: "has-text-table-item-name"
}
const _hoisted_10 = { class: "level" }
const _hoisted_11 = {
  id: "addon-view-processing-color-sharpness-label",
  class: "has-text-table-item-name"
}
const _hoisted_12 = { class: "level" }
const _hoisted_13 = {
  id: "addon-view-processing-color-gamma-label",
  class: "has-text-table-item-name"
}
const _hoisted_14 = { class: "level" }
const _hoisted_15 = { class: "level is-mobile" }
const _hoisted_16 = {
  id: "addon-view-processing-color-grayscale-label",
  class: "has-text-table-item-name"
}
const _hoisted_17 = { class: "addon-view-processing-color-controls-mobile is-hidden-desktop" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppInputRange = _resolveComponent("AppInputRange")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppToggleSwitch = _resolveComponent("AppToggleSwitch")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('rightPane.color')), 1)
      ]),
      (!_ctx.isMobile)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            id: "reset-processing-color-button",
            class: "reset-processing-color-button",
            styled: "is-none has-text-link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.resetColorProcessing()), ["prevent"])),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.resetColorProcessing()), ["prevent"]), ["space","enter"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('rightPane.resetColor')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_AppButton, {
        id: "auto-adjusut-button",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('onClickAutoAdjust')), ["prevent"])),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('onClickAutoAdjust')), ["prevent"]), ["space","enter"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('rightPane.autoAdjust')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('rightPane.bright')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AppInputRange, {
          modelValue: _ctx.currentBrightness,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentBrightness) = $event)),
          min: -100,
          max: 100,
          step: 1,
          id: "brightness-input-range",
          "fill-progress": true,
          "aria-labelledby": "addon-view-processing-color-brightness-label"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_AppInput, {
          min: -100,
          max: 100,
          modelValue: _ctx.currentBrightness,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentBrightness) = $event)),
          step: 1,
          type: "number",
          "aria-labelledby": "addon-view-processing-color-brightness-label",
          id: "brightness-input-area",
          class: "is-hidden-mobile"
        }, null, 8, ["modelValue"]),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('rightPane.contrast')), 1),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_AppInputRange, {
          modelValue: _ctx.currentContrast,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentContrast) = $event)),
          min: -50,
          max: 100,
          step: 1,
          "fill-progress": true,
          "aria-labelledby": "addon-view-processing-color-contrast-label",
          id: "contrast-input-range"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_AppInput, {
          min: -50,
          max: 100,
          step: 1,
          type: "number",
          "aria-labelledby": "addon-view-processing-color-contrast-label",
          modelValue: _ctx.currentContrast,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentContrast) = $event)),
          id: "contrast-input-area",
          class: "is-hidden-mobile"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('rightPane.sharp')), 1),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_AppInputRange, {
          modelValue: _ctx.currentSharpness,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentSharpness) = $event)),
          min: 0,
          max: 20,
          step: 1,
          "fill-progress": true,
          "aria-labelledby": "addon-view-processing-color-sharpness-label",
          id: "sharpness-input-range"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_AppInput, {
          min: 0,
          max: 20,
          step: 1,
          type: "number",
          "aria-labelledby": "addon-view-processing-color-sharpness-label",
          modelValue: _ctx.currentSharpness,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentSharpness) = $event)),
          label: _ctx.$t('rightPane.sharp'),
          id: "sharpness-input-area",
          class: "is-hidden-mobile"
        }, null, 8, ["modelValue", "label"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('rightPane.gannma')), 1),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_AppInputRange, {
          modelValue: _ctx.currentGamma,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentGamma) = $event)),
          min: 0.05,
          max: 5.0,
          step: 0.05,
          "fill-progress": true,
          "base-point": "1",
          "aria-labelledby": "addon-view-processing-color-gamma-label",
          id: "gamma-input-range"
        }, null, 8, ["modelValue", "min", "max", "step"]),
        _createVNode(_component_AppInput, {
          min: 0.05,
          max: 5.0,
          step: 0.05,
          type: "number",
          "aria-labelledby": "addon-view-processing-color-gamma-label",
          modelValue: _ctx.currentGamma,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentGamma) = $event)),
          label: _ctx.$t('rightPane.gannma'),
          id: "gamma-input-area",
          class: "is-hidden-mobile"
        }, null, 8, ["min", "max", "step", "modelValue", "label"])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('rightPane.grayscale')), 1),
        _createVNode(_component_AppToggleSwitch, {
          modelValue: _ctx.grayscaleFlag,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.grayscaleFlag) = $event)),
          isLarge: true,
          id: "grayscale-toggle-switch",
          "aria-labelledby": "addon-view-processing-color-grayscale-label"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_AppButton, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('rightPane.autoAdjust')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_AppButton, {
        styled: "is-none has-text-link",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetColorProcessing())),
        onKeydown: _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.resetColorProcessing()), ["prevent"]), ["space","enter"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('rightPane.resetColor')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}